// extracted by mini-css-extract-plugin
module.exports = {"section":"Step5_section__1y8tb","image":"Step5_image__1SYhK","desc":"Step5_desc__1XJm7"};